import { Component, Input, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { animationFrameScheduler, BehaviorSubject, lastValueFrom, Observable, scheduled } from 'rxjs';
import { map, switchMap, debounceTime } from 'rxjs/operators';
import { Advertiser } from 'src/app/api/api-campaigns.service.generated';
import { LoadingAwareComponent } from 'src/app/common/utils/loading-aware.component';
import { DeviceManagementDeviceApiClient, DeviceFilters, Device, FleetIndexResponse }
  from 'src/app/api/api-device-management.service.generated';
import { SelectDevicePopupComponent } from 'src/app/common/components/select-device-popup/select-device-popup.component';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { AsyncPipe } from '@angular/common';
import { ButtonComponent } from "wecheer-common";
import { MatProgressBar } from "@angular/material/progress-bar";

@Component({
  selector: 'app-advertiser-openers',
  templateUrl: './advertiser-openers.component.html',
  styleUrls: ['./advertiser-openers.component.scss'],
  imports: [
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    AsyncPipe,
    ButtonComponent,
    MatProgressBar
]
})
export class AdvertiserOpenersComponent extends LoadingAwareComponent implements OnInit {
  private deviceClient = inject(DeviceManagementDeviceApiClient);
  private dialog = inject(MatDialog);


  _advertiser: Advertiser;
  get advertiser() { return this._advertiser; }
  @Input() set advertiser(value: Advertiser) {
    this._advertiser = value;
  }

  private querySubject = new BehaviorSubject<string>('');
  devices$: Observable<Device[]>;

  constructor() {
    super();
    this.devices$ = this.querySubject.pipe(
      debounceTime(300),
      switchMap(text => {
        if (text.length < 5) {
          return scheduled([new FleetIndexResponse({ data: [] })], animationFrameScheduler);
        }
        return this.withLoading(this.deviceClient.searchDevices2(new DeviceFilters({ advertiserId: this._advertiser.id, mac: [text] })));
      }),
      map(response => {
        return response.data;
      })
    );
  }

  ngOnInit() { }

  async onAdd() {
    const device = await SelectDevicePopupComponent.open(this.dialog);
    if (device) {
      device.attributes.advertiserId = this._advertiser.id;
      await lastValueFrom(this.deviceClient.setDeviceAdvertiserAttribute(device));
    }
  }

  async onRemove(device: Device) {
    if (device) {
      device.attributes.advertiserId = '-';
      await lastValueFrom(this.deviceClient.setDeviceAdvertiserAttribute(device));
    }
  }

  onChange(newValue: string) {
    this.querySubject.next(newValue);
  }
}
